import flowApi from "../api/flowApi";

async function callback(processId) {
	try {
		const stepCallback = await flowApi.post(
			`/owned-processes/${processId}/steps/current/callback`
		);
		// console.log("Callback: ", stepCallback.data);
	} catch (error) {
		//TODO: make a error message showing up instead console.log error
		const message = "Erro no callback";
		// console.error(message, error);
		alert(message);
	}
}

// async function currentStepVerify(userId, workspaceId) {
//     try {
//         const res = await flowApi.get(`/owned-processes?userId=${userId}&workspaceId=${workspaceId}`)
//         const flowData = res.data
//         console.log('GET flow DATA: ', flowData)
//         let currentStep = await getCurrentHeirStep(flowData)
//         localStorage.setItem('flowData', JSON.stringify(flowData))

//         // if (flowData.steps[flowData.current].current === flowData.steps[flowData.current].steps.length - 1) await callback(flowData.id)
//         return currentStep
//     } catch (error) {
//         console.error(`Error to verify current step`, error)
//     }
// }
async function getFlowData(userId, workspaceId) {
	try {
		const res = await flowApi.get(
			`/owned-processes?userId=${userId}&workspaceId=${workspaceId}`
		);
		const flowData = res.data;
		// console.log("GET flow DATA: ", flowData);
		localStorage.setItem("flowData", JSON.stringify(flowData));
		return flowData;
	} catch (error) {
		//TODO: make a error message showing up instead console.log error
		// console.error("Error to verify current step", error);
		return []
	}
}
function getCurrentSteps(steps) {
	const currentLayerHasSubSteps = steps.every(step => step.steps);

	const [stepWithPendingStatus] = steps
		.map((step, index) => ({ ...step, index: index + 1 }))
		.filter(step => step.status === "pending");

	if (!currentLayerHasSubSteps) {
		return {
			currentLayer: steps,
			currentStep: stepWithPendingStatus
		};
	}
	
	if (!stepWithPendingStatus) return "finished"
	return getCurrentSteps(stepWithPendingStatus.steps);
}

// function getCurrentStep(step) {
// 	return step.steps ? step.steps[step.current] : null;
// }
// function getCurrentHeirStep(step) {
// 	let currentStep = getCurrentStep(step);
// 	if (!currentStep || !currentStep.status === "pending" || !currentStep.steps) return currentStep;
// 	currentStep = getCurrentHeirStep(currentStep);
// 	console.log("currentStep: ", !currentStep || isFinished(currentStep) ? step : currentStep);
// 	return !currentStep || isFinished(currentStep) ? step : currentStep;
// }

// function isFinished(step) {
// 	if (step.status === "succeeded" || step.status === "failed") return true;

// 	return false;
// }

export { getCurrentSteps, getFlowData };
